import { render, staticRenderFns } from "./TabProposalEconomic.vue?vue&type=template&id=1ef593cc&"
import script from "./TabProposalEconomic.vue?vue&type=script&lang=js&"
export * from "./TabProposalEconomic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports